import { FC } from 'react';
import { ColSizes, ROW_GUTTER } from 'utils/constants/app/ui';
import { createArray } from 'utils/helpers/create-fake-array';
import { EEventsTypes } from 'interfaces/events';
import { ISelectedGamesSkeletonProps } from 'newcomponents/Shared/sportsbook/SelectedGameCard/types';
import { Col } from 'newcomponents/UI/Col';
import { Row } from 'newcomponents/UI/Row';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

const SELECTED_GAME_CARD_SKELETON_COUNT = 3;

export const BasicSelectedGameCardSkeleton: FC<ISelectedGamesSkeletonProps> = ({
  fromSelectedGames,
  selectedEventsType
}) => {
  return (
    <div className="selectedGameCard__contanier">
      <div
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          width: '100%',
          display: 'flex'
        }}
      >
        <div className="selectedGameCard__header">
          <Skeleton
            avatar={{
              size: fromSelectedGames ? 'default' : 'small',
              shape: 'circle',
              style: { width: 20, height: 20, marginTop: 2, paddingRight: 8 }
            }}
            title={{
              style: { marginTop: 4, marginBottom: 4 }
            }}
            paragraph={false}
            active
          />
          <Skeleton
            title={{ style: { width: 30, margin: 0, height: 10 } }}
            paragraph={false}
            active
          />
        </div>
        <div className="selectedGameCard__header">
          <Skeleton
            title={{
              style: { width: 50, margin: 0, height: 10, marginLeft: 4 }
            }}
            paragraph={false}
            active
          />
          <Skeleton
            title={{
              style: { width: 20, margin: 0, height: 20, marginLeft: 4 }
            }}
            paragraph={false}
            active
          />
          <Skeleton
            title={{
              style: { width: 20, margin: 0, height: 20, marginLeft: 4 }
            }}
            paragraph={false}
            active
          />
        </div>
      </div>
      <div className="selectedGameCard__title__titleSkeleton">
        <div className="selectedGameCard__title">
          <div className="selectedGameCard__title__teamCaption__left">
            <Skeleton
              avatar={{
                shape: 'circle',
                size: fromSelectedGames ? 'default' : 'small',
                style: { width: 32, height: 32, marginTop: 2 },
                ...(fromSelectedGames && {
                  style: { marginTop: '0' }
                })
              }}
              title={{
                style: {
                  marginTop: 4,
                  marginBottom: 0,
                  alignItems: 'flex-start'
                }
              }}
              paragraph={false}
              active
            />
          </div>

          <span
            className={
              selectedEventsType !== EEventsTypes.LIVE
                ? 'selectedGameCard__title__gameInfo__vs'
                : 'selectedGameCard__title__gameInfo__live'
            }
            style={{
              background: 'none',
              border: 'none',
              padding: 0
            }}
          >
            <Skeleton
              title={{
                style: { margin: 0, height: 32, width: 36 }
              }}
              paragraph={false}
              active
            />
          </span>
          {selectedEventsType === 'live' && (
            <span className="selectedGameCard__title__gameInfo__liveRight">
              <Skeleton
                title={{
                  style: { margin: 0, height: 32, width: 36 }
                }}
                paragraph={false}
                active
              />
            </span>
          )}
          <div className="selectedGameCard__title__teamCaption__right">
            <Skeleton
              avatar={{
                shape: 'circle',
                size: fromSelectedGames ? 'default' : 'small',
                style: { width: 32, height: 32, marginTop: 2 },
                ...(fromSelectedGames && {
                  style: { marginTop: 0 }
                })
              }}
              title={{
                style: { marginTop: 4, marginBottom: 4 }
              }}
              paragraph={false}
              active
            />
          </div>
        </div>
        <Row gutterV={ROW_GUTTER._4} gutterH={ROW_GUTTER._4}>
          {createArray(SELECTED_GAME_CARD_SKELETON_COUNT).map(key => (
            <Col xs={ColSizes.SIZE_8} key={key}>
              <Skeleton
                title={{
                  style: {
                    marginTop: 0,
                    marginBottom: 0,
                    height: 32,
                    width: '100%'
                  }
                }}
                paragraph={false}
                active
              />
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};
